<script lang="ts">
  import { onMount } from 'svelte';
  import { isLoggedIn } from './utils/login.service.js';
  import { OAuthSession } from './utils/oauth-session.js';
  import Main from './components/Main.svelte';

  onMount(() => {
    if ($isLoggedIn) {
      OAuthSession.restoreLocationBeforeLogin();
    }
  });
</script>

<Main contentClass="login-content-wrapper" hasMaxWidth={false}>
  <p class="headline">Bitte melden Sie sich an.</p>
  <a href={OAuthSession.getLoginUrl()} class="login-button">Zur Anmeldung</a>
</Main>

<style lang="scss">
  @use './styles/colors';
  @use './styles/spacing';
  @use './styles/font-sizes';

  .headline {
    font-family: 'MiloSlabADAC';
    font-size: font-sizes.$text-xxl;
    margin-bottom: spacing.$l;
  }

  .login-button {
    background: colors.$primary;
    border-radius: 4px;
    padding: spacing.$s spacing.$m;
    color: colors.$white100;
    text-decoration: none;

    &:hover {
      background: colors.$primaryDark;
    }
  }
</style>
